import React from 'react';
const TextArea = ({type, name, placeholder, value, onChange, error, style}) => {
    return (
        <React.Fragment>
            <textarea
                // type={type ? type : "text"}
                name={name}
                className="form-control textarea-styling"
                placeholder={placeholder}
                value={value}
                required
                onChange={onChange}/>

            {error && <div className="alert alert-danger" style={{padding: 0}}>
                <strong>{error} </strong>
            </div>}
        </React.Fragment>
    );
};

export default TextArea;
